import { api } from "@/lib/api";
import { BaseService } from "./base.service";
import { ApiError, ApiResponse } from "@/interfaces/api.interface";
import { IProject } from "@/interfaces/project.interface";

export class ProjectService extends BaseService {
  constructor() {
    super("Project");
  }

  async getUsersProjects(): Promise<ApiResponse<IProject[]>> {
    try {
      const res = await api.get(`${process.env.REACT_APP_BASE_URL}/api/User/user-projects`);

      if (res.ok) {
        return { data: res.data as IProject[], error: null };
      }

      return { data: null, error: res.data as ApiError };
    } catch (error) {
      return { data: null, error: error as ApiError };
    }
  }
}

export const projectsSvc = new ProjectService();
